<template>
	<van-col span="12">
		<van-card
			class="house"
      v-on="$listeners"
		>
			<div slot="title" class="title" :style="{'background-color': '#' + color}">
				<span v-text="showName" style="float: left;"></span>
				<span v-text="state" style="float: right;"></span>
			</div>
			<div slot="desc" class="desc">
				<p><span class="base-desc">建筑面积：</span><span>{{area}}㎡</span></p>
				<p v-show="price > 0 && state.indexOf('非卖') == -1 && state.indexOf('自留') == -1 "><span class="base-desc">备案价格：</span><span>{{price}}元/㎡</span></p>
				<p v-show="price <= 0 || state.indexOf('非卖') != -1 || state.indexOf('自留') != -1"><span class="base-desc">&nbsp;</span></p>
			</div>
		</van-card>
	</van-col>
</template>

<script>
	import {Card} from 'vant'

	export default {
		name: 'House',
		components: {
			VanCard: Card
		},
		props: {
			showName: String,
			area: Number,
			price: Number,
			color: String,
			state: String
		}
	}
</script>

<style lang="scss">
	.van-card {
		&.house {
			margin: 10px;
			padding: 0;
			min-width: 120px;
			
			.van-card__content {
        min-height: 0;
        > div {
          display: flex;
          flex-direction: column;
        }
			}
			.title, .desc {
				padding: 8px;
			}
			.title {
				//background-color: #00FF00;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
				font-size: 16px;
			}
			.desc {
				background-color: #E9F8FF;
				border-bottom-left-radius: 5px;
				border-bottom-right-radius: 5px;
				font-size: 13px;
				line-height: 8px;
				.base-desc {
					color: #7d7e80;
				}
			}
		}
	}
</style>
